function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "LANDING-DONACI\xD3N-SANGRE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Landing-donacion-sangre",
  transform: "translate(-462.000000, -3062.000000)"
}, React.createElement("g", {
  id: "w3share",
  transform: "translate(105.000000, 2705.000000)"
}, React.createElement("g", {
  id: "follow-icons-1",
  transform: "translate(303.000000, 357.000000)"
}, React.createElement("g", {
  id: "twitter_icon",
  transform: "translate(54.000000, 0.000000)"
}, React.createElement("circle", {
  id: "circle",
  stroke: "#FFFFFF",
  cx: 19,
  cy: 19,
  r: 18.5
}), React.createElement("path", {
  d: "M25.6032422,15.7239804 C25.6136328,15.8902943 25.6136328,16.0625481 25.6136328,16.2288621 C25.6136328,21.3786553 22.1847266,27.3125 15.9191797,27.3125 C13.9865234,27.3125 12.1941406,26.6710033 10.6875,25.5662033 C10.9628516,25.6018421 11.2278125,25.6137216 11.5083594,25.6137216 C13.1033203,25.6137216 14.5683984,24.995984 15.7373438,23.950582 C14.2410938,23.9149432 12.9838281,22.792324 12.5526172,21.24798 C13.0773438,21.3370768 13.5501172,21.3370768 14.0904297,21.1767026 C12.5318359,20.8143757 11.3628906,19.2462726 11.3628906,17.3514813 L11.3628906,17.3039631 C11.8148828,17.5950125 12.3448047,17.773206 12.9007031,17.7969652 C11.9514406,17.0750656 11.3818054,15.8572945 11.3836719,14.5538428 C11.3836719,13.8291891 11.5499219,13.1639332 11.8460547,12.5877741 C13.5241406,14.9518084 16.0438672,16.4961524 18.8701172,16.6624663 C18.3869531,14.0192622 20.1169922,11.875 22.1951172,11.875 C23.1770313,11.875 24.0602344,12.344243 24.6836719,13.1045354 C25.4525781,12.9382214 26.1903125,12.6115333 26.8449219,12.1660494 C26.5903516,13.0688967 26.0552344,13.8291891 25.3486719,14.3103117 C26.0344531,14.2271547 26.6994531,14.0073826 27.3125,13.7044536 C26.8501172,14.4825654 26.2682422,15.1715804 25.6032422,15.7239804 L25.6032422,15.7239804 Z",
  id: "twitter_form",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 38 38"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/twitter.01c435e0.svg";
export { SvgComponent as ReactComponent };